/**
 * @generated SignedSource<<332c7908702c332297bbc9d60035de92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formDetailValuesId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayOrder",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FormDetailValuesCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateFormDetailValuesTPayload",
        "kind": "LinkedField",
        "name": "createFormDetailValuesT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormDetailValuesT",
            "kind": "LinkedField",
            "name": "formDetailValuesT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FormDetailValuesCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateFormDetailValuesTPayload",
        "kind": "LinkedField",
        "name": "createFormDetailValuesT",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "FormDetailValuesT",
            "kind": "LinkedField",
            "name": "formDetailValuesT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c867ec94b4d2a4376dee99b5963be34a",
    "id": null,
    "metadata": {},
    "name": "FormDetailValuesCreateMutation",
    "operationKind": "mutation",
    "text": "mutation FormDetailValuesCreateMutation(\n  $input: CreateFormDetailValuesTInput!\n) {\n  createFormDetailValuesT(input: $input) {\n    formDetailValuesT {\n      formDetailValuesId\n      displayOrder\n      text\n      created\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "bc71b95ec950a14fd473fa3ec444279b";

module.exports = node;
